import { useEffect, useState } from "react";

// If you change the `AnchorName` type below, make sure to also update `calendar.css`!
type AnchorName =
  | "branchDropdownAnchor"
  | "courseFiltersAnchor"
  | "courseTypeDropdownAnchor"
  | "theoryCourseTypeDropdownAnchor"
  | "threeDotsMenuAnchor"
  | "showOnlyCompletedEventsToggleAnchor";

export function useFullcalendarCustomButtonAnchor(name: AnchorName): undefined | HTMLDivElement {
  const [anchor, setAnchor] = useState<undefined | HTMLDivElement>();
  useEffect(() => {
    let stop = false;
    void (async () => {
      let anchorButton = undefined;
      do {
        await new Promise((resolve) => setTimeout(resolve, 100));
        if (stop) {
          return;
        }
        anchorButton = document.querySelector(`.fc-${name}-button`);
      } while (!anchorButton);
      const anchor = document.createElement("div");
      anchor.className = `fc-custom-button-anchor fc-${name}-anchor`;
      anchorButton.insertAdjacentElement("beforebegin", anchor);
      setAnchor(anchor);
    })();
    return () => {
      stop = true;
    };
  }, []);
  return anchor;
}
